import React from 'react';
import {Form, Icon, Input, Button, Spin, Row, Col} from 'antd';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import * as actions from '../store/actions/auth'

const antIcon = <Icon type="loading" style={{ fontSize: 24 }} spin />;
  
  class NormalLoginForm extends React.Component {
    handleSubmit = (e) => {
      e.preventDefault();
      this.props.form.validateFields((err, values) => {
        if (!err) {
          this.props.onAuth(values.username, values.password);
        }
      });
      this.props.history.push('/');
    }
  
    render() {

        let errorMessage = null;
        if(this.props.error){
            errorMessage = (
                <p>{this.props.error.message}</p>
            );
        }
      const { getFieldDecorator } = this.props.form;
      return (
          <div>
              {errorMessage}
              {
                this.props.loading ?
                  <Spin indicator={antIcon} />
                  :
                  <div>
                      <Row type="flex" justify="center">
                        <Col sm={6} xs={16}>
                            <h2 style={{color: "#1890ff", margin: "12px", textAlign: 'center'}}>TIA Hr</h2> 
                        </Col>
                     </Row>

                     <Row type="flex" justify="center">
                      <Col sm={6} xs={16}>
                        <Form onSubmit={this.handleSubmit} className="login-form">
                        <Form.Item>
                            {getFieldDecorator('username', {
                            rules: [{ required: true, message: 'Please input your Username!' }],
                            })(
                            <Input style={{ height: '3em' }} prefix={<Icon type="user" style={{ color: 'rgba(0,0,0,.25)' }} />} placeholder="Username" />
                            )}
                        </Form.Item>
                        <Form.Item>
                            {getFieldDecorator('password', {
                            rules: [{ required: true, message: 'Please input your Password!' }],
                            })(
                            <Input style={{ height: '3em' }} prefix={<Icon type="lock" style={{ color: 'rgba(0,0,0,.25)' }} />} type="password" placeholder="Password" />
                            )}
                        </Form.Item>
                        <Form.Item>
                            <Button type="primary" htmlType="submit" style={{marginRight: '10px', width: '100%'}}>
                                Login
                            </Button>
                            {/* <Row type="flex" justify="center">
                                <Col>
                                    <NavLink style={{marginRight: '10px'}} to='/login'> 
                                        I forgot my password
                                    </NavLink>
                                </Col>
                            </Row> */}
                            
                        </Form.Item>
                    </Form>
                      </Col>
                  </Row>
                  </div>
                  
                  
                
              }
          </div>
        
      );
    }
  }
  
  const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(NormalLoginForm);
  
  const mapStateToProps = state => {
      return {
          loading: state.loading,
          error: state.error
      }
  }

  const mapDispatchToProps = dispatch => {
      return {
          onAuth: (username, password) => dispatch(actions.authLogin(username, password)) 
      }
  }
export default connect(mapStateToProps, mapDispatchToProps)(WrappedNormalLoginForm);